import React from 'react';
import { AuthInfo, ForgetPasswordView } from '../../components/auth';

interface Props {}
// @ts-ignore
export const ForgetPasswordPage: React.FC<Props> = ({ children }) => {
  return (
    <div className=" lg:w-full md:w-auto">
      <div className="lg:flex min-h-screen lg:min-h-screen lg:border">
        <div className="hidden lg:flex lg:w-full md:w-1/2">
          <AuthInfo />
        </div>
        <div className=" lg:w-full lg:min-h-full bg-[rgb(242,249,253)] mx-auto">
          <ForgetPasswordView />
        </div>
      </div>
    </div>
  );
};
